module.exports = __webpack_public_path__ + "static/media/ic_bbps_report.3e7f4fba.png";